import type { CSSProperties } from 'react';

/** Lucide via CDN (lucide-static). O SVG entra como máscara CSS para o glifo
 *  herdar `currentColor` — nunca redesenhe um ícone da Fórmula MED à mão. */
const CDN = 'https://unpkg.com/lucide-static@0.544.0/icons/';

export interface IconProps {
    /** Nome do ícone no Lucide, ex.: `calendar`. */
    name: string;
    size?: number;
    /** Sobrescreve `currentColor`. */
    strokeColor?: string;
    /** Com título, o ícone vira `img` com nome acessível; sem, é decorativo. */
    title?: string;
    style?: CSSProperties;
}

export function Icon({ name, size = 16, strokeColor, style, title }: IconProps) {
    const url = `url("${CDN}${name}.svg")`;
    return (
        <span
            role={title ? 'img' : 'presentation'} aria-label={title} title={title}
            style={{
                display: 'inline-block', width: size, height: size, flex: '0 0 auto',
                background: strokeColor || 'currentColor',
                WebkitMaskImage: url, maskImage: url,
                WebkitMaskRepeat: 'no-repeat', maskRepeat: 'no-repeat',
                WebkitMaskPosition: 'center', maskPosition: 'center',
                WebkitMaskSize: 'contain', maskSize: 'contain',
                ...style,
            }}
        />
    );
}
